import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})
export class MultiigrejaProvider {

  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(public http: HttpClient) { }

  getSetorFiltro() {
    return this.http.get<any>(this.baseUrl + '/instituicao/setor-filtro');
  }

  getCidade(idEstado: any) {
    return this.http.post<any>(this.baseUrl + '/instituicao/cidade', { idEstado: idEstado })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getEstado() {
    return this.http.get<any>(this.baseUrl + '/instituicao/estado');
  }

  getInstituicaoList(filtro: any, pag: { currentPage: any; }, setor: any, estado: any, cidade: any) {
    return this.http.get<any>(this.baseUrl + '/instituicao/instituicao-list',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro,
          "setor": setor,
          "estado": estado,
          "cidade": cidade,
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          instituicao: data.body,
          pagination: pag
        };
      }));
  }

  getInstituicaoFilhas(id: any) {
    return this.http.post<any>(this.baseUrl + '/instituicao/instituicao-filhas', { id: id })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getLinksUteis(id: any) {
    return this.http.post<any>(this.baseUrl + '/instituicao/links-uteis', { id: id })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }


}
